module.exports = __webpack_public_path__ + "static/img/Dictionary.025f6c54.png";